// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Cookies from "js-cookie";
// import {
//   MdPeople,
//   MdPerson,
//   MdArrowForward,
//   MdEventNote,
// } from "react-icons/md";
// import doctorService from "../../Services/doctorService";

// const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

// function fmtDate(str) {
//   if (!str) return "—";
//   const d = new Date(str);
//   return `${MONTHS[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
// }

// function DonutChart({ written, pending }) {
//   const total = written + pending;
//   const radius = 60;
//   const stroke = 18;
//   const circumference = 2 * Math.PI * radius;

//   const writtenPct = total === 0 ? 0 : written / total;
//   const writtenLength = circumference * writtenPct;
//   const pendingLength = circumference - writtenLength;

//   return (
//     <div className="flex items-center gap-6" style={{ fontFamily: "'Poppins', sans-serif" }}>
//       <svg width="150" height="150" viewBox="0 0 150 150">
//         <g transform="translate(75,75) rotate(-90)">
//           {/* background track */}
//           <circle
//             r={radius}
//             fill="none"
//             stroke="#f3f4f6"
//             strokeWidth={stroke}
//           />
//           {total > 0 && (
//             <>
//               {/* written portion */}
//               <circle
//                 r={radius}
//                 fill="none"
//                 stroke="#10b981"
//                 strokeWidth={stroke}
//                 strokeDasharray={`${writtenLength} ${circumference - writtenLength}`}
//                 strokeLinecap="round"
//               />
//               {/* pending portion */}
//               <circle
//                 r={radius}
//                 fill="none"
//                 stroke="#f59e0b"
//                 strokeWidth={stroke}
//                 strokeDasharray={`${pendingLength} ${circumference - pendingLength}`}
//                 strokeDashoffset={-writtenLength}
//                 strokeLinecap="round"
//               />
//             </>
//           )}
//         </g>
//         <text
//           x="75"
//           y="70"
//           textAnchor="middle"
//           className="fill-gray-700"
//           style={{ fontSize: "26px", fontWeight: 600, fontFamily: "'Poppins', sans-serif" }}
//         >
//           {total}
//         </text>
//         <text
//           x="75"
//           y="90"
//           textAnchor="middle"
//           className="fill-gray-400"
//           style={{ fontSize: "11px", fontFamily: "'Poppins', sans-serif" }}
//         >
//           Total Today
//         </text>
//       </svg>

//       <div className="flex flex-col gap-3">
//         <div className="flex items-center gap-2">
//           <span className="w-3 h-3 rounded-full bg-emerald-500" />
//           <span className="text-sm text-gray-600">Written</span>
//           <span className="text-sm font-semibold text-gray-800 ml-1">{written}</span>
//         </div>
//         <div className="flex items-center gap-2">
//           <span className="w-3 h-3 rounded-full bg-amber-500" />
//           <span className="text-sm text-gray-600">Pending</span>
//           <span className="text-sm font-semibold text-gray-800 ml-1">{pending}</span>
//         </div>
//       </div>
//     </div>
//   );
// }

// // Simple dependency-free bar chart comparing today vs total patients
// function ComparisonBarChart({ todayCount, totalCount }) {
//   const max = Math.max(todayCount, totalCount, 1);
//   const bars = [
//      { label: "Today", value: todayCount, color: "#D0E0FC" },
//     { label: "Total", value: totalCount, color: "#225187" },
//   ];

//   return (
//     <div className="flex items-end gap-8 h-40 px-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
//       {bars.map((b) => (
//         <div key={b.label} className="flex flex-col items-center gap-2">
//           <span className="text-sm font-semibold text-gray-700">{b.value}</span>
//           <div
//             className="w-14 rounded-t-md transition-all"
//             style={{
//               height: `${(b.value / max) * 100}px`,
//               backgroundColor: b.color,
//               minHeight: b.value > 0 ? "6px" : "2px",
//             }}
//           />
//           <span className="text-xs text-gray-400">{b.label}</span>
//         </div>
//       ))}
//     </div>
//   );
// }

// export default function Dashboard() {
//   const navigate = useNavigate();
//   const doctor = JSON.parse(Cookies.get("doctor") || "{}");

//   const [todayPatients, setTodayPatients] = useState([]);
//   const [allPatients, setAllPatients] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const load = async () => {
//       try {
//         const [tp, ap] = await Promise.allSettled([
//           doctorService.getTodayPatients(doctor.id),
//           doctorService.getAllPatients(doctor.id),
//         ]);

//         if (tp.status === "fulfilled") setTodayPatients(tp.value.patients || []);
//         else console.error("getTodayPatients failed:", tp.reason);

//         if (ap.status === "fulfilled") setAllPatients(ap.value.patients || []);
//         else console.error("getAllPatients failed:", ap.reason);
//       } catch (e) {
//         console.error(e);
//       } finally {
//         setLoading(false);
//       }
//     };
//     load();
//   }, [doctor.id]);

//   const pendingPrescriptions = todayPatients.filter((p) => !p.prescription_id).length;
//   const writtenPrescriptions = todayPatients.length - pendingPrescriptions;

//   const today = new Date();
//   const dayNames = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];

//   return (
//     <div style={{ fontFamily: "'Poppins', sans-serif" }}>
//       <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');`}</style>
//       {/* Header */}
//       <div className="mb-6">
//         <h1 className="text-gray-800 text-xl font-semibold">
//   Good {today.getHours() < 12 ? "Morning" : today.getHours() < 17 ? "Afternoon" : "Evening"},  {doctor?.name}
// </h1>
//         <p className="text-gray-400 text-sm mt-0.5">
//           {dayNames[today.getDay()]}, {MONTHS[today.getMonth()]} {today.getDate()} {today.getFullYear()}
//         </p>
//       </div>

//       {/* Stats Row */}
//       <div className="grid grid-cols-3 gap-4 mb-6">
//         <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
//           <p className="text-xs text-gray-400 mb-1">Today's Patients</p>
//           <p className="text-2xl font-semibold text-blue-600">{loading ? "—" : todayPatients.length}</p>
//         </div>
//         <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
//           <p className="text-xs text-gray-400 mb-1">Total Patients</p>
//           <p className="text-2xl font-semibold text-gray-700">{loading ? "—" : allPatients.length}</p>
//         </div>
//         <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
//           <p className="text-xs text-gray-400 mb-1">Pending RX</p>
//           <p className="text-2xl font-semibold text-amber-500">{loading ? "—" : pendingPrescriptions}</p>
//         </div>
//       </div>

//       {/* Charts Row */}
//       <div className="grid grid-cols-2 gap-4 mb-6">
//         <div className="bg-white border border-gray-100 rounded-xl p-5 shadow-sm">
//           <p className="text-sm font-medium text-gray-700 mb-4">Prescription Status (Today)</p>
//           {loading ? (
//             <div className="py-8 text-center text-gray-400 text-sm">Loading...</div>
//           ) : todayPatients.length === 0 ? (
//             <div className="py-8 text-center text-gray-400 text-sm">No data for today</div>
//           ) : (
//             <DonutChart written={writtenPrescriptions} pending={pendingPrescriptions} />
//           )}
//         </div>

//         <div className="bg-white border border-gray-100 rounded-xl p-5 shadow-sm">
//           <p className="text-sm font-medium text-gray-700 mb-4">Today vs Total Patients</p>
//           {loading ? (
//             <div className="py-8 text-center text-gray-400 text-sm">Loading...</div>
//           ) : (
//             <div className="flex justify-center">
//               <ComparisonBarChart todayCount={todayPatients.length} totalCount={allPatients.length} />
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Today's Patients Table */}
//       <div className="bg-white border border-gray-100 rounded-xl shadow-sm overflow-hidden">
//         <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
//           <div className="flex items-center gap-2">
//             <span className="text-gray-800 font-medium text-sm">Today's Patients</span>
//             <span className="text-xs text-gray-400 bg-gray-100 px-2 py-0.5 rounded-full">
//               {todayPatients.length} records
//             </span>
//           </div>
//           <button
//             onClick={() => navigate("/patients")}
//             className="flex items-center gap-1 text-xs text-blue-600 hover:text-blue-700 font-medium"
//           >
//             View all <MdArrowForward size={14} />
//           </button>
//         </div>

//         {loading ? (
//           <div className="py-12 text-center text-gray-400 text-sm">Loading...</div>
//         ) : todayPatients.length === 0 ? (
//           <div className="py-12 text-center">
//             <MdEventNote size={36} className="text-gray-200 mx-auto mb-2" />
//             <p className="text-gray-400 text-sm">No patients assigned today</p>
//           </div>
//         ) : (
//           <div className="overflow-x-auto">
//             <table className="w-full text-sm">
//               <thead>
//                 <tr className="bg-[#225187]">
//                   {["SR","Patient Name","Contact","CNIC","Fee","Date","RX Status","Action"].map((h) => (
//                     <th key={h} className="text-left text-white/80 text-xs font-medium px-4 py-3 whitespace-nowrap">
//                       {h}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {todayPatients.map((p, i) => (
//                   <tr key={p.sale_id} className="border-b border-gray-50 hover:bg-gray-50 transition-colors">
//                     <td className="px-4 py-3 text-gray-400 text-xs">{i + 1}</td>
//                     <td className="px-4 py-3">
//                       <div className="flex items-center gap-2">
//                         <div className="w-7 h-7 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
//                           <MdPerson size={14} className="text-blue-600" />
//                         </div>
//                         <span className="font-medium text-gray-700 whitespace-nowrap">{p.full_name}</span>
//                       </div>
//                     </td>
//                     <td className="px-4 py-3 text-gray-500 text-xs whitespace-nowrap">{p.contact_number || "—"}</td>
//                     <td className="px-4 py-3 text-gray-500 text-xs whitespace-nowrap">{p.cnic || "—"}</td>
//                     <td className="px-4 py-3 text-gray-700 font-medium text-xs whitespace-nowrap">Rs. {p.fee}</td>
//                     <td className="px-4 py-3 text-gray-500 text-xs whitespace-nowrap">{fmtDate(p.checkup_date)}</td>
//                     <td className="px-4 py-3">
//                       {p.prescription_id ? (
//                         <span className="inline-flex items-center gap-1 text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full">
//                           Written
//                         </span>
//                       ) : (
//                         <span className="inline-flex items-center gap-1 text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">
//                           Pending
//                         </span>
//                       )}
//                     </td>
//                     <td className="px-4 py-3">
//                       <button
//                         onClick={() => navigate(`/patients/${p.sale_id}`)}
//                         className="text-xs text-blue-600 hover:text-blue-700 font-medium border border-blue-100 hover:border-blue-300 px-3 py-1 rounded-lg transition-all"
//                       >
//                         View
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import {
  MdPerson,
  MdArrowForward,
  MdEventNote,
} from "react-icons/md";
import doctorService from "../../Services/doctorService";

const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

function fmtDate(str) {
  if (!str) return "—";
  const d = new Date(str);
  return `${MONTHS[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
}

// Same dedup used in Patients.jsx
function dedupeBySaleId(arr) {
  const seen = new Set();
  return arr.filter((p) => {
    if (seen.has(p.sale_id)) return false;
    seen.add(p.sale_id);
    return true;
  });
}

function DonutChart({ written, pending }) {
  const total = written + pending;
  const radius = 60;
  const stroke = 18;
  const circumference = 2 * Math.PI * radius;

  const writtenPct = total === 0 ? 0 : written / total;
  const writtenLength = circumference * writtenPct;
  const pendingLength = circumference - writtenLength;

  return (
    <div className="flex items-center gap-6" style={{ fontFamily: "'Poppins', sans-serif" }}>
      <svg width="150" height="150" viewBox="0 0 150 150">
        <g transform="translate(75,75) rotate(-90)">
          <circle r={radius} fill="none" stroke="#f3f4f6" strokeWidth={stroke} />
          {total > 0 && (
            <>
              <circle
                r={radius} fill="none" stroke="#10b981" strokeWidth={stroke}
                strokeDasharray={`${writtenLength} ${circumference - writtenLength}`}
                strokeLinecap="round"
              />
              <circle
                r={radius} fill="none" stroke="#f59e0b" strokeWidth={stroke}
                strokeDasharray={`${pendingLength} ${circumference - pendingLength}`}
                strokeDashoffset={-writtenLength}
                strokeLinecap="round"
              />
            </>
          )}
        </g>
        <text x="75" y="70" textAnchor="middle" className="fill-gray-700"
          style={{ fontSize: "26px", fontWeight: 600, fontFamily: "'Poppins', sans-serif" }}>
          {total}
        </text>
        <text x="75" y="90" textAnchor="middle" className="fill-gray-400"
          style={{ fontSize: "11px", fontFamily: "'Poppins', sans-serif" }}>
          Total Today
        </text>
      </svg>
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-2">
          <span className="w-3 h-3 rounded-full bg-emerald-500" />
          <span className="text-sm text-gray-600">Written</span>
          <span className="text-sm font-semibold text-gray-800 ml-1">{written}</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="w-3 h-3 rounded-full bg-amber-500" />
          <span className="text-sm text-gray-600">Pending</span>
          <span className="text-sm font-semibold text-gray-800 ml-1">{pending}</span>
        </div>
      </div>
    </div>
  );
}

function ComparisonBarChart({ todayCount, totalCount }) {
  const max = Math.max(todayCount, totalCount, 1);
  const bars = [
    { label: "Today", value: todayCount, color: "#D0E0FC" },
    { label: "Total", value: totalCount, color: "#225187" },
  ];
  return (
    <div className="flex items-end gap-8 h-40 px-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
      {bars.map((b) => (
        <div key={b.label} className="flex flex-col items-center gap-2">
          <span className="text-sm font-semibold text-gray-700">{b.value}</span>
          <div className="w-14 rounded-t-md transition-all"
            style={{ height: `${(b.value / max) * 100}px`, backgroundColor: b.color, minHeight: b.value > 0 ? "6px" : "2px" }}
          />
          <span className="text-xs text-gray-400">{b.label}</span>
        </div>
      ))}
    </div>
  );
}

export default function Dashboard() {
  const navigate = useNavigate();
  const doctor = JSON.parse(Cookies.get("doctor") || "{}");

  const [todayPatients, setTodayPatients] = useState([]);
  const [allPatients, setAllPatients]     = useState([]);
  const [loading, setLoading]             = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const [tp, ap] = await Promise.allSettled([
          doctorService.getTodayPatients(doctor.id),
          doctorService.getAllPatients(doctor.id),
        ]);

        if (tp.status === "fulfilled")
          setTodayPatients(dedupeBySaleId(tp.value.patients || []));
        else console.error("getTodayPatients failed:", tp.reason);

        if (ap.status === "fulfilled")
          setAllPatients(dedupeBySaleId(ap.value.patients || []));
        else console.error("getAllPatients failed:", ap.reason);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [doctor.id]);

  const pendingPrescriptions = todayPatients.filter((p) => !p.prescription_id).length;
  const writtenPrescriptions  = todayPatients.length - pendingPrescriptions;

  const today    = new Date();
  const dayNames = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];

  return (
    <div style={{ fontFamily: "'Poppins', sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');`}</style>

      {/* Header */}
      <div className="mb-6">
        <h1 className="text-gray-800 text-xl font-semibold">
          Good {today.getHours() < 12 ? "Morning" : today.getHours() < 17 ? "Afternoon" : "Evening"}, {doctor?.name}
        </h1>
        <p className="text-gray-400 text-sm mt-0.5">
          {dayNames[today.getDay()]}, {MONTHS[today.getMonth()]} {today.getDate()} {today.getFullYear()}
        </p>
      </div>

      {/* Stats Row */}
      <div className="grid grid-cols-3 gap-4 mb-6">
        <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
          <p className="text-xs text-gray-400 mb-1">Today's Patients</p>
          <p className="text-2xl font-semibold text-blue-600">{loading ? "—" : todayPatients.length}</p>
        </div>
        <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
          <p className="text-xs text-gray-400 mb-1">Total Patients</p>
          <p className="text-2xl font-semibold text-gray-700">{loading ? "—" : allPatients.length}</p>
        </div>
        <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
          <p className="text-xs text-gray-400 mb-1">Pending RX</p>
          <p className="text-2xl font-semibold text-amber-500">{loading ? "—" : pendingPrescriptions}</p>
        </div>
      </div>

      {/* Charts Row */}
      <div className="grid grid-cols-2 gap-4 mb-6">
        <div className="bg-white border border-gray-100 rounded-xl p-5 shadow-sm">
          <p className="text-sm font-medium text-gray-700 mb-4">Prescription Status (Today)</p>
          {loading ? (
            <div className="py-8 text-center text-gray-400 text-sm">Loading...</div>
          ) : todayPatients.length === 0 ? (
            <div className="py-8 text-center text-gray-400 text-sm">No data for today</div>
          ) : (
            <DonutChart written={writtenPrescriptions} pending={pendingPrescriptions} />
          )}
        </div>
        <div className="bg-white border border-gray-100 rounded-xl p-5 shadow-sm">
          <p className="text-sm font-medium text-gray-700 mb-4">Today vs Total Patients</p>
          {loading ? (
            <div className="py-8 text-center text-gray-400 text-sm">Loading...</div>
          ) : (
            <div className="flex justify-center">
              <ComparisonBarChart todayCount={todayPatients.length} totalCount={allPatients.length} />
            </div>
          )}
        </div>
      </div>

      {/* Today's Patients Table */}
      <div className="bg-white border border-gray-100 rounded-xl shadow-sm overflow-hidden">
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
          <div className="flex items-center gap-2">
            <span className="text-gray-800 font-medium text-sm">Today's Patients</span>
            <span className="text-xs text-gray-400 bg-gray-100 px-2 py-0.5 rounded-full">
              {todayPatients.length} records
            </span>
          </div>
          <button
            onClick={() => navigate("/patients")}
            className="flex items-center gap-1 text-xs text-blue-600 hover:text-blue-700 font-medium"
          >
            View all <MdArrowForward size={14} />
          </button>
        </div>

        {loading ? (
          <div className="py-12 text-center text-gray-400 text-sm">Loading...</div>
        ) : todayPatients.length === 0 ? (
          <div className="py-12 text-center">
            <MdEventNote size={36} className="text-gray-200 mx-auto mb-2" />
            <p className="text-gray-400 text-sm">No patients assigned today</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-[#225187]">
                  {["SR","Patient Name","Contact","CNIC","Fee","Date","RX Status","Action"].map((h) => (
                    <th key={h} className="text-left text-white/80 text-xs font-medium px-4 py-3 whitespace-nowrap">
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {todayPatients.map((p, i) => (
                  <tr key={p.sale_id} className="border-b border-gray-50 hover:bg-gray-50 transition-colors">
                    <td className="px-4 py-3 text-gray-400 text-xs">{i + 1}</td>
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-2">
                        <div className="w-7 h-7 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                          <MdPerson size={14} className="text-blue-600" />
                        </div>
                        <span className="font-medium text-gray-700 whitespace-nowrap">{p.full_name}</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-gray-500 text-xs whitespace-nowrap">{p.contact_number || "—"}</td>
                    <td className="px-4 py-3 text-gray-500 text-xs whitespace-nowrap">{p.cnic || "—"}</td>
                    <td className="px-4 py-3 text-gray-700 font-medium text-xs whitespace-nowrap">Rs. {p.fee}</td>
                    <td className="px-4 py-3 text-gray-500 text-xs whitespace-nowrap">{fmtDate(p.checkup_date)}</td>
                    <td className="px-4 py-3">
                      {p.prescription_id ? (
                        <span className="inline-flex items-center gap-1 text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full">Written</span>
                      ) : (
                        <span className="inline-flex items-center gap-1 text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">Pending</span>
                      )}
                    </td>
                    <td className="px-4 py-3">
                      <button
                        onClick={() => navigate(`/patients/${p.sale_id}`)}
                        className="text-xs text-blue-600 hover:text-blue-700 font-medium border border-blue-100 hover:border-blue-300 px-3 py-1 rounded-lg transition-all"
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}